import { t } from "i18next";
import React from "react";
import { FaCalendarAlt } from "react-icons/fa";

interface CustomDatePickerInputProps {
    value?: string;
    onClick?: () => void;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    error?: boolean;
    onManualChange?: (value: string) => void;
    displayValue?: string;
    onClear?: () => void;
}

const CustomDatePickerInput = React.forwardRef<HTMLInputElement, CustomDatePickerInputProps>(
    ({ value, onClick, onChange, error, onManualChange, displayValue, onClear }, ref) => {
        const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            let inputValue = event.target.value;
            
            // Formattazione automatica: aggiungi gli slash mentre digiti
            // Accetta solo numeri
            inputValue = inputValue.replace(/\D/g, '');
            
            // Limita a 8 caratteri totali (2 gg + 2 mm + 4 yyyy)
            if (inputValue.length > 8) {
                inputValue = inputValue.slice(0, 8);
            }
            
            if (inputValue.length <= 2) {
                // GG (max 2 cifre)
                inputValue = inputValue;
            } else if (inputValue.length <= 4) {
                // GG/MM (max 2+2 cifre)
                inputValue = inputValue.slice(0, 2) + '/' + inputValue.slice(2, 4);
            } else if (inputValue.length <= 8) {
                // GG/MM/YYYY (max 2+2+4 cifre)
                inputValue = inputValue.slice(0, 2) + '/' + inputValue.slice(2, 4) + '/' + inputValue.slice(4, 8);
            }
            
            // Chiama il callback di input manuale se disponibile
            if (onManualChange) {
                onManualChange(inputValue);
            }
        };

        const handleIconClick = (e: React.MouseEvent) => {
            e.stopPropagation();
            if (onClick) {
                onClick();
            }
        };

        const handleClearClick = (e: React.MouseEvent) => {
            e.stopPropagation();
            if (onClear) {
                onClear();
            }
        };

        return (
            <div className="relative w-full">
                <input
                    value={displayValue || value || ''}
                    onChange={handleInputChange}
                    ref={ref}
                    className={`border ${error ? 'border-red' : 'border-[#6F6F6F]'} input-text leading-[18px] text-black text-[15px] bg-white border  rounded-[8px] p-[10px] pr-[60px] w-full`}
                    placeholder={t('screens.profile.deteFormat') as string}
                />
                {displayValue && (
                    <button
                        type="button"
                        onClick={handleClearClick}
                        className="absolute right-10 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer bg-transparent border-none p-1"
                        tabIndex={-1}
                        title="Cancella data"
                    >
                        ✕
                    </button>
                )}
                <button
                    type="button"
                    onClick={handleIconClick}
                    className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer bg-transparent border-none p-1"
                    tabIndex={-1}
                >
                    <FaCalendarAlt className="w-5 h-5" />
                </button>
            </div>
        );
    }
);

CustomDatePickerInput.displayName = "CustomDatePickerInput";
export default CustomDatePickerInput;
